export default "__VITE_ASSET__BVnySni8__"